<div>
    <section class="filter">
        <div class="manipulations-wrapper">
            <div class="manipulations-top">
                <section class="right">
                    <div *ngIf="isQuestionnariePage" class="my-questionnaires-split-btn">
                        <div *ngIf="isRoleAdmim$()" class="split-btn-item" (click)="toggleAllQuestionnaires()"
                            [ngClass]="{ 'active': !selectedFilter$()?.generalQuestionnaires && !selectedFilter$()?.myQuestionnaires}"
                            translate>
                            grid.menu.managedByMe
                        </div>
                        <div class="split-btn-item" (click)="toggleMyQuestionnaires()"
                            [ngClass]="{ 'active': selectedFilter$()?.myQuestionnaires }" translate>
                            grid.menu.myQuestionnaires
                        </div>
                        <div class="split-btn-item" (click)="toggleGeneralQuestionnaires()"
                            [ngClass]="{ 'active': selectedFilter$()?.generalQuestionnaires }" translate>
                            grid.menu.generalQuestionnaires
                        </div>

                    </div>
                    <div *ngIf="pageType$() == enumPage.Approvals && (countTabs() >= 1)" class="my-questionnaires-split-btn">
                        <div class="split-btn-item" (click)="toggleApprovalsTab(enumApprovalsTabs.PendingApproval)"
                            *ngIf="showTabApprovers()" [ngClass]="{ 'active': pendingApprovalTab$() }" translate>
                            grid.menu.pendingApproval
                        </div>
                        <div class="split-btn-item" (click)="toggleApprovalsTab(enumApprovalsTabs.AfterApproval)"
                            *ngIf="showTabApprovers()" [ngClass]="{ 'active': afterApprovalTab$() }" translate>
                            grid.menu.afterApproval
                        </div>
                        <div class="split-btn-item" (click)="toggleApprovalsTab(enumApprovalsTabs.DownloadRecords)"
                            *ngIf="showTabRecords()" [ngClass]="{ 'active': downloadRecordsTab$() }" translate>
                            grid.menu.downloadRecords
                        </div>
                        <div class="split-btn-item" (click)="toggleApprovalsTab(enumApprovalsTabs.Reports)"
                            *ngIf="showTabRecords()" [ngClass]="{ 'active': reportsTab$() }" translate>
                            grid.menu.reports
                        </div>

                    </div>

                    <div class="input-with-image" *ngIf="!isEmpty">
                        <img src="/assets/images/cards/search.svg">
                        <div [ngSwitch]="lastUrlSegment">
                            <input *ngSwitchCase="'questionnaires'" type="text" [formControl]="filter"
                                placeholder="{{'search.searchQuestionnaires'| translate}}">
                            <input *ngSwitchCase="'distributionGroups'" type="text" [formControl]="filter"
                                placeholder="{{'search.searchDistributionGroups'| translate}}">
                            <input *ngSwitchCase="'reminders'" type="text" [formControl]="filter"
                                placeholder="{{'search.searchReminders'| translate}}">
                            <input *ngSwitchCase="'savedLists'" type="text" [formControl]="filter"
                                placeholder="{{'search.searcLists'| translate}}">
                            <input *ngSwitchCase="'approvals'" type="text" [formControl]="filter"
                                placeholder="{{'search.searchApprovals'| translate}}">
                        </div>
                        <img *ngIf="filter.value" src="/assets/images/definitions/reset-input.svg"
                            (click)="resetInput()">
                    </div>
                    <div class="wrap filter-item"
                        *ngIf="!isEmpty && (pageType$() != enumPage.Approvals || !downloadRecordsTab$())"
                        [ngClass]="{'filter-open':isFilterListOpen$(),'filter-select':filterExists() ,'no-open':!isFilterListOpen$()}"
                        (click)="ChnageIsOpenFilter()">
                        <img src="/assets/images/filter-icon.svg" />
                        <h5 translate>filter.filter</h5>
                        <div class="reset-filter" (click)="resetFilters($event)" *ngIf="filterExists()">
                            <img src="/assets/images/definitions/reset-input.svg" />
                            <div class="circle-of-filter">{{filterNumber()}}</div>
                        </div>
                    </div>

                </section>
                <section class="left">
                    <div
                        *ngIf="pageType$() == enumPage.Approvals && (afterApprovalTab$() || downloadRecordsTab$())">
                        <button #trigger (click)="toggleDownloadDropdown($event)" class="btn white pdf">
                            <img src="/assets/images/export/download.svg"></button>
                        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                            [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
                            cdkConnectedOverlayBackdropClass="backdrop-selection"
                            (backdropClick)="isDownloadDropdownOpen=false"
                            [cdkConnectedOverlayOpen]="isDownloadDropdownOpen"
                            [cdkConnectedOverlayPositions]="positonArea">
                            <div class="overlay-warp">
                                <div class="download-option"
                                    (click)="downloadRecord(enumRecordsTypes.PayrollRepresentative)"
                                    *ngIf="isRoleAdmim$() || isPayrollRepresentative$()" translate>
                                    column.approvals.downloadPayrollReport
                                </div>
                                <div class="download-option"
                                    (click)="downloadRecord(enumRecordsTypes.AccountingRepresentative)"
                                    *ngIf="isRoleAdmim$() || isAccountingRepresentative$()" translate>
                                    column.approvals.downloadAccountingReport
                                </div>
                                <div class="download-option"
                                    (click)="downloadRecord(enumRecordsTypes.Billing)"
                                    *ngIf="isRoleAdmim$() || isBillingRepresentative$()" translate>
                                    column.approvals.downloadBillingReport
                                </div>
                            </div>
                        </ng-template>
                    </div>

                    <div *ngIf="pageType$() == enumPage.Approvals && reportsTab$() && !isEmpty">
                        <button class="btn white pdf" (click)="exportReportsToExcel()">
                            <img src="/assets/images/export/download.svg" />
                            <span translate>grid.reports.exportToExcel</span>
                        </button>
                    </div>

                    <div *ngIf="displaySlideToggleType" class="warp-active-toggle">
                        <p *ngIf="displaySlideToggleType=='groups'" translate>grid.groupsNotActive</p>
                        <p *ngIf="displaySlideToggleType=='lists'" translate>grid.listsNotActive</p>
                        <que-toggle [toggleState]="isDisplayNotActiveItems$()"
                            (toggleEvent)="changeActiveState($event)"></que-toggle>
                    </div>
                    <div class="button-select-view" *ngIf="isTowViews">
                        <div (click)="changeToListView()" class="select-view-item pointer"
                            [ngClass]="{'active':isListView$() }">
                            <img class="scale-img"
                                src="/assets/images/list-view-{{isListView$()?client:'default'}}.svg" />
                        </div>
                        <div (click)="changeToGridView()" class="select-view-item pointer"
                            [ngClass]="{'active':!isListView$() }">
                            <img class="scale-img"
                                src="/assets/images/grid-view-{{!isListView$()?client:'default'}}.svg" />
                        </div>
                    </div>
                </section>
            </div>
            <div class="manipulations-filter">
                <que-result-filter *ngIf="isFilterListOpen$()"></que-result-filter>
            </div>
        </div>
    </section>
</div>